import { render } from "./choose-tag.vue?vue&type=template&id=fe5f17b8&scoped=true&ts=true"
import script from "./choose-tag.vue?vue&type=script&lang=ts"
export * from "./choose-tag.vue?vue&type=script&lang=ts"

import "./choose-tag.vue?vue&type=style&index=0&id=fe5f17b8&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe5f17b8"]])

export default __exports__